import React, { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

const VerifyEmailPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState(token ? 'checking' : 'no-token');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const ran = useRef(false);

  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const { data } = await api.post('/auth/verify-email', { token });
        setMessage(data.message || 'Email confirmed.');
        setState('done');
      } catch (err) {
        setMessage(err.response?.data?.message || 'That link did not work.');
        setState('failed');
      }
    })();
  }, [token]);

  const resend = async () => {
    if (!email.trim()) return toast.error('Enter your email address');
    setSending(true);
    try {
      const { data } = await api.post('/auth/resend-verification', { email });
      toast.success(data.message || 'Sent');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed');
    } finally { setSending(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--cr-primary)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 24px 20px' }}>
        <h1 style={{ color: 'white', fontSize: '24px', fontWeight: '700' }}>Connected Rider</h1>
      </div>

      <div style={{ background: 'white', borderRadius: '24px 24px 0 0', padding: '28px 24px 40px' }}>
        {state === 'checking' && (
          <div style={{ textAlign: 'center' }}>
            <div className="spinner" style={{ margin: '0 auto 14px' }} />
            <p style={{ fontSize: 14, color: 'var(--text-secondary)' }}>Confirming your email...</p>
          </div>
        )}

        {state === 'done' && (
          <>
            <h2 style={{ marginBottom: 10, textAlign: 'center' }}>Email confirmed</h2>
            <p style={{ fontSize: 14, color: 'var(--text-secondary)', textAlign: 'center', marginBottom: 22 }}>{message}</p>
            <Link to="/login" className="btn btn-primary btn-full btn-lg" style={{ textDecoration: 'none', display: 'block', textAlign: 'center' }}>
              Sign in
            </Link>
          </>
        )}

        {(state === 'failed' || state === 'no-token') && (
          <>
            <h2 style={{ marginBottom: 10, textAlign: 'center' }}>Link didn't work</h2>
            <p style={{ fontSize: 14, color: 'var(--text-secondary)', textAlign: 'center', marginBottom: 18 }}>
              {state === 'no-token' ? 'This link is missing its code.' : message}
            </p>
            <div className="form-group">
              <label className="form-label">Send a new link to</label>
              <input className="form-input" type="email" placeholder="your@email.com"
                value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <button className="btn btn-primary btn-full btn-lg" onClick={resend} disabled={sending}>
              {sending ? 'Sending...' : 'Send new link'}
            </button>
            <p style={{ textAlign: 'center', marginTop: 18, fontSize: 14 }}>
              <Link to="/login" style={{ color: 'var(--cr-primary)', fontWeight: '500', textDecoration: 'none' }}>Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
